<tidy-wrapper style="background:#FFFFFF" class="full-btm-padding">
  @if (loaded) {
    <tidy-card>
      <tidy-row class="extra-bottom-padding">
        <tidy-grid>
          <tidy-row>
            <ion-row>
              <ion-col size="6">
                <tidy-row>
                  <tidy-text
                    [title]="'Invoice From'" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="invoice?.team?.owner?.name | titlecase" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="invoice?.team?.owner?.email" />
                </tidy-row>
                <tidy-row>
                  <tidy-text
                    [body]="invoice?.team?.owner?.phone | telephone" />
                </tidy-row>
              </ion-col>
            </ion-row>
          </tidy-row>
        </tidy-grid>
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <!--TODO divider to have [color] input and add dynamic color-->
        <tidy-divider
          class="full-card-width thick"
          style="background: #275C7C" />
      </tidy-row>
      <div style="margin-top: -15px; background: #292929; margin-left: -15px; margin-right: -15px; padding: 15px; padding-top:10px ">
        <tidy-row [alignLastItemRight]="true">
          <div>
            <tidy-text
              [body]="('To: ' | translate) + (invoice?.customer?.name | titlecase)" />
          </div>
          <div style="align-self: start">
            <tidy-text
              [body]="('Sent ' | translate) + (invoice?.created_at | parseDateTime:'MMM d yyyy':'local')" />
          </div>
        </tidy-row>
      </div>
      <tidy-row class="extra-top-padding" [alignLastItemRight]="true">
        <tidy-text
          [body]="'Service'" />
        <tidy-text
          [body]="'Owed'" />
      </tidy-row>
      <tidy-row class="extra-bottom-padding">
        <tidy-divider />
      </tidy-row>
      @for (service of invoice?.items; track service; let last = $last) {
        <tidy-row [alignLastItemRight]="true">
          <div style="width:85%">
            <tidy-text
              [header]="service?.service_details?.name | titlecase" />
          </div>
          <div>
            <tidy-text
              [body]="service?.amount | tcurrency" />
          </div>
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="(service?.service_details?.date | parseDateTime:'MMM d yyyy') + (' at ' | translate) + service?.service_details?.address?.address + ', ' + (service?.service_details?.address?.unit ? (('Unit ' | translate) + (service?.service_details?.address?.unit | translate) + ', ') : '') + service?.service_details?.address?.zip" />
        </tidy-row>
        <tidy-row class="extra-top-padding" [ngClass] = "last ? '' : 'extra-bottom-padding'">
          <tidy-divider />
        </tidy-row>
      }
      @if (creditWithPro > 0) {
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
          <tidy-text
            [header]="'Credit with Pro'" />
          <tidy-text
            [body]="creditWithPro | tcurrency" />
        </tidy-row>
      }
      @if (creditWithTIDY > 0) {
        <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
          <tidy-text
            [header]="'TIDY Credit'" />
          <tidy-text
            [body]="creditWithTIDY | tcurrency" />
        </tidy-row>
      }
      <tidy-row [alignLastItemRight]="true" class="extra-top-padding">
        <tidy-text
          [header]="'Total'" />
        <tidy-text
          [body]="'<b>' + (totalOwed | tcurrency) + '</b>'" />
      </tidy-row>
      <tidy-row [align]="'center'" class="extra-top-padding">
        <tidy-text
          [body]="'We thank you for your business!'" />
      </tidy-row>
      <tidy-row class="no-padding" [align]="'center'">
        <tidy-text
          [body]="invoice?.team?.owner?.name"
          class="signature" />
      </tidy-row>
      <tidy-divider
        style="margin-top:-15px" />
    </tidy-card>
  }
</tidy-wrapper>
